import { Component, OnInit, ViewChild } from "@angular/core";
import { AbstractControl, FormBuilder, FormGroup, NgForm, Validators } from "@angular/forms";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { map } from "rxjs/operators";
import { FetchDataService } from "src/app/core/services/fetch-data.service";
import Swal from "sweetalert2";

@Component({
    selector: "app-register",
    templateUrl: "./register.component.html",
    styleUrls: ["./register.component.scss"]
})
export class RegisterComponent implements OnInit {
    registerForm: FormGroup;
    verifyLink;
    verifyId;
    countryCodesList = [];
    registerType;
    @ViewChild("formDir") private formDir: NgForm;
    responseMessage;
    errorMessage;
    email;
    id;
    type;
    hide: boolean = true;
    hides: boolean = true;
    maxD: any;
    shown: boolean;
    hideRest = true;
isSwitchMode = false;
    constructor(private fb: FormBuilder, private fd: FetchDataService, private ad: ActivatedRoute, private router: Router) { }

    ngOnInit(): void {
  this.hideRest = false;

        this.ad.queryParamMap.subscribe((params: Params) => {

    // const roleSwitch = params['roleSwitch'];


    const mode = params.get('mode');
    const userType = params['user_type'];
            this.email = params.get('email');
            this.id = params.get('id');
            this.type = params.get('type');

    this.initializeForm();
     if (mode === 'switch') {
          this.isSwitchMode = true;
      const userType = params.get('user_type');
      this.handleRoleSwitch(userType);
      setTimeout(() => {
  console.log("Form Value After Patch:", this.registerForm.getRawValue());
}, 100);
      return;   // ⛔ STOP here
    }
    else{  
        
            const hash = this.router.url.split('=')[1];
            this.verifyEmail(hash);
        this.getCountryCodes();

    
//             this.registerForm = this.fb.group(
//                 {
//                     id: [this.id],
//                     email: [this.email, [Validators.required, Validators.email]],
//                     // password: ['', [Validators.required, Validators.minLength(6), Validators.pattern(/^[a-zA-Z0-9]+$/)]],
//                     // rpassword: ['', [Validators.required, Validators.minLength(6), Validators.pattern(/^[a-zA-Z0-9]+$/)]],
//                    password: [
//   '',
//   [
//     Validators.required,
//     Validators.minLength(6),
//     Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{6,}$/)
//   ]
// ],
// rpassword: [
//   '',
//   [
//     Validators.required,
//     Validators.minLength(6),
//     Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{6,}$/)
//   ]
// ],

//     acceptTerms: [false, Validators.requiredTrue],
//     first_name: ['', [Validators.required]],
//                     last_name: ['', [Validators.required, Validators.minLength(3)]],
//                     country: ['', Validators.required],
//                     country_code: ['', Validators.required],
//                     phone: ['', [Validators.required, Validators.minLength(10)]],
//                     register_as: ['', Validators.required],
//                     companies: ['']
//                 },
//                 { validators: this.passwordConfirming }
//             );

    }});

    }

    showPassword() {
        this.hide = !this.hide;
    }

    showPassword2() {
        this.hides = !this.hides;
    }

    // funcsubtitle(event) {
    //     if (event.target.value == 2) {
    //         this.shown = true;
    //         this.registerForm.get('companies')?.setValidators([Validators.required]);
    //     } else {
    //         this.shown = false;
    //         this.registerForm.get('companies')?.clearValidators();
    //     }
    //     this.registerForm.get('companies')?.updateValueAndValidity();
    // }
funcsubtitle(event) {
    if (event.target.value === '2') {
        this.shown = true;
        this.registerForm.get('companies')?.setValidators([Validators.required]);
    } else {
        this.shown = false;
        this.registerForm.get('companies')?.clearValidators();
    }
    this.registerForm.get('companies')?.updateValueAndValidity();
}


    // allowOnlyAlphabets(event: KeyboardEvent): void {
    //     const charCode = event.key.charCodeAt(0);
    //     if ((charCode >= 65 && charCode <= 90) || (charCode >= 97 && charCode <= 122)) {
    //         return;
    //     } else {
    //         event.preventDefault();
    //     }
    // }
  allowOnlyAlphabets(event: KeyboardEvent): void {
  const key = event.key;
  const allowedKeys = [
    'Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete', ' ', // allow navigation & editing
  ];

  // Allow alphabets (a-z, A-Z) and allowedKeys
  if (!/^[a-zA-Z]$/.test(key) && !allowedKeys.includes(key)) {
    event.preventDefault();
  }
}



    alphanumericValidator(control: any) {
        const alphanumericPattern = /^[a-zA-Z0-9]*$/;
        if (control.value && !alphanumericPattern.test(control.value)) {
            return { nonAlphanumeric: true };
        }
        return null;
    }

    verifyEmail(hash: string) {
        const formData = new FormData();
        formData.append("h", hash);
        this.fd.verifyEmail(formData).subscribe((res) => {
            console.log('verifyEmail response:', res);

            if (res.code == 1) {
                this.hideRest = false;
                this.registerType = res.data.type;
                this.verifyId = res.data.id;

                this.registerForm.patchValue({
                    id: res.data.id,
                    email: res.data.email
                });
            } else if (res.code == 0) {
                setTimeout(() => this.router.navigate(["/error/0"]), 1000);
            } else if (res.code == 2) {
                setTimeout(() => this.router.navigate(["/error/2"]), 1000);
            }
        });
    }

    getCountryCodes() {
        this.fd.getCountryCodes()
            .pipe(map((data: any) => {
                this.countryCodesList = data.result;
                console.log("Country Codes:", this.countryCodesList);
            }))
            .subscribe();
    }

    // passwordConfirming(c: AbstractControl): { invalid: boolean } {
    //     if (c.get("password").value !== c.get("rpassword").value) {
    //         return { invalid: true };
    //     }
    //     return null;
    // }
    passwordConfirming(group: FormGroup): { [key: string]: boolean } | null {
        const password = group.get('password')?.value;
        const confirmPassword = group.get('rpassword')?.value;

        return password === confirmPassword ? null : { invalid: true };
    }


    isNumber(evt) {
        evt = evt ? evt : window.event;
        var charCode = evt.which ? evt.which : evt.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            return false;
        }
        return true;
    }

    // onSelectCountry(item) {
    //     if (item == 'India') {
    //         this.maxD = '10';
    //     } else {
    //         this.maxD = '15';
    //     }

    //     const indx = this.countryCodesList.findIndex((m) => m.name === item);
    //     if (indx !== -1) {
    //         this.registerForm.patchValue({
    //             country_code: this.countryCodesList[indx]["phonecode"]
    //         });
    //     }
    // }
onSelectCountry(item) {
  const indx = this.countryCodesList.findIndex(m => m.name === item);

  if (indx !== -1) {
    const code =   this.countryCodesList[indx].phonecode;

    // maxlength set
    this.maxD = item === 'India' ? 13 : 16; // +91 + 10 digits

    // backend ke liye
    this.registerForm.patchValue({
      country_code: this.countryCodesList[indx].phonecode
    });

    const phoneControl = this.registerForm.get('phone');
    const currentValue = phoneControl?.value || '';

    // agar code pehle se nahi hai to add karo
    if (!currentValue.startsWith(code)) {
      phoneControl?.setValue(code + ' ');
    }
  }
}

    onSubmitRegisterForm() {
        console.log("Form Values:", this.registerForm.value);
        window.scrollTo({ top: 0, behavior: "smooth" });
  const acceptTerms = this.registerForm.get("acceptTerms").value;
        if (this.registerForm.valid) {

const mode = this.ad.snapshot.queryParams['mode'];

    if (mode === 'switch') {
      this.submitSecondRole();
    } else {
      
    
  
            const formData = new FormData();
            formData.append("id", this.registerForm.get("id").value);
            formData.append("email", this.registerForm.get("email").value);
            formData.append("password", this.registerForm.get("password").value);
            formData.append("rpassword", this.registerForm.get("rpassword").value);
            formData.append("first_name", this.registerForm.get("first_name").value);
            formData.append("last_name", this.registerForm.get("last_name").value);
            formData.append("country", this.registerForm.get("country").value);
            formData.append("country_code", this.registerForm.get("country_code").value);
            formData.append("phone", this.registerForm.get("phone").value);
            formData.append("company_name", this.registerForm.get("companies").value);
            formData.append("register_as", this.registerForm.get("register_as").value);
 formData.append("acceptTerms", acceptTerms);
            this.fd.signup(formData).subscribe((res) => {
                console.log('Signup Response:', res);
                if (res.code == 1) {
                    Swal.fire({
                        position: 'top-end',
                        icon: 'success',
                        title: 'Your registration request has been received successfully. It takes less than 24 hours to review. You would be receiving an email with an update.',
                        showConfirmButton: true,  // Show OK button
                        confirmButtonText: 'OK'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            this.router.navigate(['/account/login']);
                        }
                    });
                } else {
                    this.errorMessage = "Please try again.";
                }
            });
        }
    }
    }
    
initializeForm() {

  this.registerForm = this.fb.group(
    {
      id: [this.id],
      email: [this.email, [Validators.required, Validators.email]],
      password: ['', Validators.required],
      rpassword: ['', Validators.required],
      acceptTerms: [false, Validators.requiredTrue],
      first_name: ['', Validators.required],
      last_name: ['', Validators.required],
      country: ['', Validators.required],
      country_code: ['', Validators.required],
      phone: ['', Validators.required],
      register_as: ['', Validators.required],
      companies: ['']
    },
    { validators: this.passwordConfirming }
  );
}
handleRoleSwitch(userType: string) {


  const userData = JSON.parse(localStorage.getItem('clpUser') || '{}');
  const email = localStorage.getItem('email');

  console.log("Switch User Data:", userData);
  this.registerForm.patchValue({
    id: userData.uid,
    email:email,
    first_name: userData.first_name,
    last_name: userData.last_name,
    country: userData.country,
    phone: userData.phone
  });

  // Disable fields (non editable)
  this.registerForm.get('email')?.disable();
  this.registerForm.get('first_name')?.disable();
  this.registerForm.get('last_name')?.disable();
  this.registerForm.get('country')?.disable();
  this.registerForm.get('phone')?.disable();

  // Set register_as automatically based on role switch
  this.registerForm.patchValue({
    register_as: userType
  });

  this.registerType = userType;
}
submitSecondRole() {

  const userData = JSON.parse(localStorage.getItem('clpUser') || '{}');
  const email = localStorage.getItem('email');

  const payload = {
    user_id: userData.uid,
    email: email,
    user_type: this.registerForm.get('register_as')?.value
  };

  this.fd.createSecondUser(payload).subscribe(res => {
alert("enter")
    if (res.code == 1) {
alert("1")
      Swal.fire({
        icon: 'success',
        title: 'Profile created successfully'
      }).then(() => {

        localStorage.setItem('userType', payload.user_type);

        if (payload.user_type == '1') {
          this.router.navigate(['/buyer/marketplace']);
        } else {
            alert("2")
          this.router.navigate(['/seller/dashboard']);
        }

      });
    }
  });
}

}
